import React from 'react';
import { useStyles, cx } from '../../../lib/styles';
import Typography from '../Typography';
import calloutStyles from './Callout_styles';
import { CalloutProps } from './Callout';

export interface AuthorCalloutProps extends CalloutProps {
  author: {
    name: string;
    description: string;
    avatar_48: string;
    username?: string;
    title?: string;
    tagline?: string;
    link?: string;
    avatar_24?: string;
    avatar_96?: string;
  }
}

/**
 * A callout. Generally used as a low-impact card on side-rails.
 */
export const AuthorCallout = (props: AuthorCalloutProps) => {
  const { author, children, className } = props;
  const { title, name, tagline, description, avatar_48 } = author;

  const styles = useStyles(calloutStyles(props));

  return (
    <div className={cx('AuthorCallout flex-column', styles.callout, className)}>
      <div 
        className={cx(`meta-container`, styles.authorCalloutMetaContainer)}
      >
        <div className="author-avatar">
          <img 
            src={avatar_48} alt={name} 
            style={{
              borderRadius: '50%',
            }}
          />
        </div>
        <Typography color={`primary`}>
          <h3
            className={styles.calloutHeading}
          >
            {name}
          </h3>
        </Typography>
      </div>

      {description && 
        <div
          className={styles.calloutBody}
          dangerouslySetInnerHTML={{
            __html: description,
          }}
        />
      }

      {children && <div className={styles.calloutBody}>{children}</div>}
    </div>
  );
};

export default AuthorCallout;
